import React from "react";

import { DashboardPageTemplate } from "../../Utils/DashboardPageTemplate";

export const ShippingDashboard = () => {
  return <DashboardPageTemplate pageName={"shipping"} />;
};
